import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sign_wall_edit",
  "use": "icon-sign_wall_edit-usage",
  "viewBox": "0 0 13.953 13.805",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.953 13.805\" id=\"icon-sign_wall_edit\"><defs><style>#icon-sign_wall_edit .a{fill:none;stroke:#1890ff;}</style></defs><g transform=\"translate(-1072.061 -418.079)\"><path class=\"a\" d=\"M1072.377,418.579h-8.816v12.805h12.953v-9.9\" transform=\"translate(9)\" /><path class=\"a\" d=\"M1076.514,418.135l-6.892,7.245\" transform=\"translate(8 1)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol